import { useCallback, useRef, useState } from 'react';
import classnames from 'classnames';

import { translation } from '@hh.ru/front-static-app';
import Down, { DownPlacement } from 'bloko/blocks/drop/Down';
import { IconColor, IconDynamic, UserScaleMediumKindSingleEnclosedTrue } from 'bloko/blocks/icon';
import Text, { TextImportance } from 'bloko/blocks/text';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { format } from 'bloko/common/trl';

import Logout from 'src/components/Logout';
import Unsudo from 'src/components/Logout/Unsudo';
import { useSelector } from 'src/modules/useSelector';
import getFullName from 'src/utils/getFullName';

import styles from 'src/components/Profile/profile.less';

const TrlKeys = {
    employerManager: 'statportal.profile.employerManager',
};

interface ProfileProps {
    isFull: boolean;
}

const Profile: TranslatedComponent<ProfileProps> = ({ isFull, trls }) => {
    const [show, toggleShow] = useState(false);
    const parentRef = useRef<HTMLDivElement>(null);
    const employer = useSelector((state) => state.employer);
    const employerManager = useSelector((state) => state.employerManager);

    const fullName = employerManager ? getFullName(employerManager) : '';

    const renderDropDown = useCallback(() => {
        return (
            <div className={styles.profilePanel} data-qa="profile-panel">
                <div className={styles.profileOption}>
                    <div className={styles.profileCompanyName} data-qa="profile-company-name">
                        {employer.name}
                    </div>
                    <Text importance={TextImportance.Secondary} data-qa="profile-client">
                        {format(trls[TrlKeys.employerManager], {
                            '{0}': fullName,
                            '{1}': employer?.id ? employer.id : '',
                        })}
                    </Text>
                </div>
                {employer.actualId && (
                    <div className={styles.profileOption}>
                        <Unsudo />
                    </div>
                )}
                <div className={styles.profileOptionSeparate} />
                <Logout />
            </div>
        );
    }, [employer.actualId, employer.id, employer.name, fullName, trls]);

    const toggleDropDown = () => {
        toggleShow(!show);
    };

    return (
        <div ref={parentRef}>
            <Down
                show={show}
                onClose={toggleDropDown}
                render={renderDropDown}
                placement={DownPlacement.TopStart}
                // родитель Down с position: fixed. Поэтому для правильного позиционирования
                // и сам Down должен вставляться внутрь него, а не в body, например
                host={parentRef.current}
            >
                <IconDynamic>
                    <button
                        className={classnames(styles.profile, {
                            [styles.profileFull]: isFull,
                        })}
                        onClick={toggleDropDown}
                        data-qa="profile"
                    >
                        <span className={styles.profileIcon}>
                            <UserScaleMediumKindSingleEnclosedTrue
                                initial={IconColor.Gray80}
                                highlighted={IconColor.Blue60}
                            />
                        </span>
                        <div className={styles.profileText}>№{employer?.id}</div>
                    </button>
                </IconDynamic>
            </Down>
        </div>
    );
};

export default translation(Profile);
